import { AccountCircleOutlined, ArrowRightAlt, BarChart, Delete, DeleteOutline, DeleteTwoTone, Edit, EditOutlined, FolderOutlined, FolderSpecial, FolderSpecialOutlined, FolderSpecialTwoTone, GraphicEqOutlined, MoreHoriz, MoreVert, PlayArrow } from "@mui/icons-material"
import { alpha, Avatar, Box, Breadcrumbs, Chip, IconButton, Menu, MenuItem, Popover, Typography, useTheme } from "@mui/material"
import { font } from "../../styles/font"
import { blue, brown, green, grey, red } from "@mui/material/colors";
import { useState } from "react";
import { LightTooltip } from "../styled/CustomComponent";
import { useTranslation } from "react-i18next";
import ShortcutText from "../common/ShortcutText";
import { KeyboardKeys } from "../../constant/KeyboardKeys";
import { OrganisationCustomIcon, ProgramCustomIcon, ProjectCustomIcon, TestCaseCustomIcon, UseCaseCustomIcon, UserStoryCustomIcon } from "../styled/CustomIcons";
import CreatedByAvatar from "../common/CreatedByAvatar";
import { Entity, Entity_Label } from "../../constant/ApplicationVariables";
import { CARD_COLOR } from "../../constant/ApplicationJson";
// import { Key } from 'ts-key-enum'


const ITEM_HEIGHT = 48;


function OrganisationCard({ item, handleClick, handleEditClick, handleClickDelete }) {
    const theme = useTheme();
    const { t } = useTranslation('translation', { keyPrefix: 'project' });

    let cardColor = CARD_COLOR[Entity.organisation] || grey[50]

    const options = [
        {
            label: "Edit Story",
            icon: <Edit sx={{ color: theme.palette.secondary.main }} />,
            onClick: () => console.log("Edit Story"),
        },
        {
            label: "Delete Story",
            icon: <Delete color="error" />,
            onClick: () => console.log("Delete Story"),
        },
    ];

    const [moreAnchorEl, setMoreAchorEl] = useState(null);

    const handleEdit = (e) => {
        e && e.stopPropagation();
        handleEditClick();
    }

    const handleDelete = (e) => {
        e && e.stopPropagation();
        handleClickDelete();
    }

    const handleOpenMore = (event) => {
        setMoreAchorEl(event.currentTarget);
    };
    const handleCloseMore = () => {
        setMoreAchorEl(null);
    };

    return (
        <Box className=" flex flex-col justify-between w-full h-full gap-4 px-4 py-4" title="organisation card" borderRadius={theme.shape.borderRadius} border={`1px solid ${theme.palette.divider}`} >

            {/* upper container */}
            <Box className="flex items-center gap-2 px-0 ">
                <Avatar variant="rounded" sx={{ width: "fit-content", height: "fit-content", px: "0.4rem", py: "0.4rem", background: alpha(cardColor, 0.1), color: cardColor }}>
                    <OrganisationCustomIcon sx={{ fontSize: font.size.fs_3, color: "inherit" }} />
                </Avatar>

                <Box className="flex-1 flex items-center justify-end gap-2  " >
                    <LightTooltip
                        title={<Box className="flex items-center gap-1">
                            <Typography fontSize={font.size.fs_5} color="textPrimary">{t("editText")}</Typography>
                            <ShortcutText keyboardShortcutText={KeyboardKeys.F2} textColor="textSecondary" />
                        </Box>}>
                        <IconButton color="info" onClick={handleEdit}>
                            <EditOutlined />
                        </IconButton>
                    </LightTooltip>

                    <LightTooltip
                        title={<Box className="flex items-center gap-1">
                            <Typography fontSize={font.size.fs_5} color="textPrimary">{t("deleteText")}</Typography>
                            <ShortcutText keyboardShortcutText={KeyboardKeys.Delete} textColor="textSecondary" />
                        </Box>}>
                        <IconButton color="error" onClick={handleDelete}>
                            <DeleteOutline />
                        </IconButton>
                    </LightTooltip>

                </Box>
            </Box>

            {/* main container */}
            <Box className="flex-1 flex flex-col  gap-4  " onClick={() => { handleClick(item) }}>

                <Box className="flex-1 flex flex-col gap-0  cursor-pointer  " >
                    <Typography fontSize={font.size.fs_4} color={theme.palette.text.primary} className=" line-clamp-1 ">{"Organisation Name" || item?.name}</Typography>
                    <Typography fontSize={font.size.fs_5} color={theme.palette.text.secondary} className=" line-clamp-2">{"Description" || item?.description}</Typography>
                </Box>

                {/* bottom container */}
                <Box className="flex items-center justify-between gap-2   " >
                    <ItemCount icon={<ProgramCustomIcon style={{ color: CARD_COLOR[Entity.programme] }} />} label={Entity_Label.programme} value={item?.projectCount || 0} />
                    {item?.createdBy && <CreatedByAvatar data={item} />}
                </Box>


            </Box>


            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={moreAnchorEl}
                open={Boolean(moreAnchorEl)}
                onClose={handleCloseMore}
                slotProps={{
                    paper: {
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: '20ch',
                        },
                    },
                }}
            >
                {options.map((option, index) => (
                    <MenuItem key={index} onClick={handleCloseMore} className="flex items-center gap-2">
                        {option?.icon}
                        {option?.label}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    )
}

export default OrganisationCard


function ItemCount({ icon, label, value }) {
    const theme = useTheme();

    return (
        <Chip
            icon={icon}
            label={`${label}: ${value}`}
            size="small"
            variant="outlined"
            sx={{
                fontSize: font.size.fs_6,
                color: theme.palette.text.secondary,
                // backgroundColor: theme.palette.secondary.light,
                backgroundColor: "transparent",
                borderRadius: theme.shape.borderRadius,
                '& .MuiChip-icon': {
                    marginRight: theme.spacing(0.5),
                },
            }}
        />
    )
}
